import './BotSavingIndicator.pcss';
import React from 'react';
import { useSyncManager } from './use-sync-manager';

const BotSavingIndicator = () => {
  const { isProcessing } = useSyncManager();

  return (
    <div className="bot-saving-indicator">
      <div className="bot-saving-indicator__saved-icon-wrapper">
        {isProcessing ? (
          <span>
            <i className="far fa-square" /> Saving...
          </span>
        ) : (
          <span>
            <i className="far fa-check-square" /> Saved
          </span>
        )}
      </div>
    </div>
  );
};

export default BotSavingIndicator;
